import { SkeletonLoader } from '@postscript/components';
import React from 'react';
import styled from 'styled-components';

const SkeletonStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
`;

const SkeletonCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  padding: var(--spacing-3);
  background: var(--surface-bkg-color);
  border: 1px solid var(--border-color-dim);
  border-radius: var(--border-radius-medium);
`;

// Three skeleton cards approximating section heights: a tall identity
// card, then two shorter row-card stacks. Skeletons stay structural —
// no spinner — so the drawer never feels blocked.
export const MessageDetailsSkeleton: React.FC = () => (
  <SkeletonStack aria-busy="true" aria-label="Loading message details">
    <SkeletonCard>
      <SkeletonLoader type="body-text-medium" width="full" animate />
      <SkeletonLoader type="body-text-small" width="full" animate />
      <SkeletonLoader type="body-text-small" width={140} animate />
    </SkeletonCard>
    <SkeletonCard>
      <SkeletonLoader type="body-text-small" width={120} animate />
      <SkeletonLoader type="body-text-small" width="full" animate />
      <SkeletonLoader type="body-text-small" width="full" animate />
    </SkeletonCard>
    <SkeletonCard>
      <SkeletonLoader type="body-text-small" width={120} animate />
      <SkeletonLoader type="body-text-small" width="full" animate />
    </SkeletonCard>
  </SkeletonStack>
);
